import react, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { addUser, checkEmail } from "../../services/signupService";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [planval, setPlanval] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [paddleReady, setPaddleReady] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;

    script.onload = () => {
      if (window.Paddle) {
        window.Paddle.Environment.set("sandbox");

        window.Paddle.Initialize({
          token: "test_21d1cf74b8f979932dc60c53517",
          eventCallback: (data) => {
            console.log("Paddle event:", data);

            if (data.name === "checkout.completed") {
              console.log("✅ Payment complete. Redirecting...", email);
              navigate("/createtweet", {
                // replace: true,
                state: { loginSuccess: true },
              });
              setEmail("");
              setPassword("");
              setConfirmPassword("");
            }
          },
        });

        setPaddleReady(true);
      }
    };

    document.body.appendChild(script);
  }, []);

  const handleCheckout = () => {
    if (!window.Paddle || !paddleReady) return;

    // Define items
    const items = [{ priceId: "pri_01jvvbxgfsfbyvgagftbbt8m25", quantity: 1 }];

    // Define customer info
    const customer = {
      email: "sam@example.com",
      address: {
        countryCode: "US",
        postalCode: "10021",
      },
    };

    // Open Paddle Checkout
    window.Paddle.Checkout.open({
      items,
      customer,
    });
  };

  const [searchParams] = useSearchParams();
  // Get individual parameter
  const val = searchParams.get("val");

  useEffect(() => {
    console.log(val);
    if (val == 10) {
      setPlanval("Starter Plan");
    } else if (val == 20) {
      setPlanval("Pro Plan");
    } else {
      setPlanval("Free Plan");
    }
  }, [val]);

  let data = {};
  data.email = email;
  data.password = confirmPassword;
  data.plan = val;

  // Fake API call for email check (replace with real endpoint)
  const checkEmailAvailability = async (email) => {
    // Build query string
    const queryParams = new URLSearchParams({
      email: email,
    });

    const res = await checkEmail(queryParams);
    // console.log(res.data.data.available);
    // const data = await res.json();
    return res.data.data.available; // should return true/false
  };

  const registerUser = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validate passwords
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // Validate email availability
    setLoading(true);
    const available = await checkEmailAvailability(email);
    if (!available) {
      setLoading(false);
      setError("Email is already taken");
      return;
    }
    console.log(data);
    createUser();
    setEmail("");
  };

  const createUser = () => {
    addUser(data)
      .then((response) => {
        let data = response.data.data;
        console.log(response.data);
        if (response.data.error === false && planval !== "Free Plan") {
          let token = response.data.data.token;
          localStorage.setItem("token", token);
          handleCheckout();
        }
        if (planval === "Free Plan") {
          setSuccess("Registration successful!");
          let token = response.data.data.token;
          localStorage.setItem("token", token); // Store the token in localStorage
          navigate("/createtweet", {
            // replace: true,
            state: { loginSuccess: true },
          });
          setEmail("");
          setPassword("");
          setConfirmPassword("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="flex min-h-full flex-1">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <h1 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                BlogSlicer
              </h1>
              <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                You have selected {planval}
              </h2>
            </div>

            <div className="mt-10">
              <div>
                <form
                  method="POST"
                  className="space-y-6"
                  onSubmit={registerUser}
                >
                  {/* Email */}
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Email address
                    </label>
                    <div className="mt-2">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        id="email"
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  {/* Password */}
                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Password
                    </label>
                    <div className="mt-2">
                      <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        id="password"
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div>
                    <label
                      htmlFor="confirmPassword"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Confirm Password
                    </label>
                    <div className="mt-2">
                      <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        id="confirmPassword"
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  {/* Error / Success Messages */}
                  {error && <p className="text-red-600 text-sm">{error}</p>}
                  {success && (
                    <p className="text-green-600 text-sm">{success}</p>
                  )}

                  {/* Submit */}
                  <div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50"
                    >
                      {loading ? "Processing..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 lg:block min-h-[720px]">
          <img
            alt=""
            src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80"
            className="absolute inset-0 size-full object-cover"
          />
        </div>
      </div>
    </>
  );
}
